import React from "react";
import OfferLeben from '../offer-leben'
import OfferRenten from '../offer-ren'
import OfferRisleb from '../offer-risleb'
import OfferKsp from '../offer-ksp'
import OfferVid from '../offer-vid'
import OfferVidt from '../offer-vidt'
import OfferRis from '../offer-ris'

class Offer extends React.Component {
    constructor(props) {
        super(props)
    }


    render () {
        const offerTypes = {
            LEB: OfferLeben,
            REN: OfferRenten,
            FOR: OfferRenten,
            RISLEB: OfferRisleb,
            KSP: OfferKsp,
            VID: OfferVid,
            VIDT: OfferVidt,
            RIS: OfferRis,
        }

        
        const ComponentName = offerTypes[this.props.offerType]
        return (
            <ComponentName {...this.props} />
        )
    }
}

export default Offer